/* ==========================================================================
   EN blog listing controller — search + topic filter, in place.
   --------------------------------------------------------------------------
   One view model over three modes, all swapping [data-en-blog-results]:
     • all    — every article        → blog section, base blog URL
     • tag    — a curated topic       → blog section, /tagged/<handle> URL
     • search — full-text article     → en-blog-search-results section, ?q=
   Search is debounced on pause; topic pills filter on click; pagination is
   in place in every mode. Keeps the user on the blog URL, with real history.
   No-JS path is unaffected: the form submits and the pills navigate natively.
   ========================================================================== */
(function () {
  var form = document.querySelector('[data-en-blog-search]');
  var results = document.querySelector('[data-en-blog-results]');
  if (!form || !results) return;

  var input = form.querySelector('[data-en-blog-search-input]');
  var clearBtn = form.querySelector('[data-en-blog-search-clear]');
  if (!input) return;

  var DEBOUNCE = 400;
  var MIN_CHARS = 2;
  var SEARCH_SECTION = 'en-blog-search-results';
  var SEARCH_PATH = form.getAttribute('action') || '/search';

  var blogSection = document.querySelector('[data-section-type="blog"]');
  var BLOG_SECTION_ID = blogSection ? blogSection.getAttribute('data-section-id') : null;

  var pills = Array.prototype.slice.call(document.querySelectorAll('[data-en-blog-filter]'));
  var allPill = null;
  pills.forEach(function (p) { if (p.hasAttribute('data-en-blog-filter-all')) allPill = p; });
  var BLOG_BASE = allPill ? allPill.getAttribute('href') : window.location.pathname.split('/tagged/')[0];

  var timer = null;
  var controller = null;
  var currentView = null;
  var currentPage = 1;
  var allHTML = null; // cached all-articles page-1 markup for instant restore

  function setLoading(on) { results.classList.toggle('is-loading', on); }
  function showClear(show) { if (clearBtn) clearBtn.classList.toggle('is-hidden', !show); }
  function markCardsShown() {
    var c = results.querySelectorAll('[data-aos]');
    for (var i = 0; i < c.length; i++) c[i].classList.add('aos-animate');
  }

  function allView() { return { mode: 'all', baseHref: BLOG_BASE, sectionId: BLOG_SECTION_ID }; }
  function tagView(tag, href) {
    return { mode: 'tag', tag: tag, baseHref: href || (BLOG_BASE + '/tagged/' + tag), sectionId: BLOG_SECTION_ID };
  }
  function searchView(q) { return { mode: 'search', query: q, sectionId: SEARCH_SECTION }; }

  function setActivePill(pill) {
    pills.forEach(function (p) { p.classList.remove('is-active'); });
    if (pill) pill.classList.add('is-active');
  }
  function pillForTag(tag) {
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].getAttribute('data-en-blog-filter-tag') === tag) return pills[i];
    }
    return null;
  }
  function pageFromHref(href) {
    if (!href) return 1;
    var m = href.match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  // Scope the query to article titles only (Shopify field syntax: title:term).
  function titleScope(q) {
    return q.trim().split(/\s+/).filter(Boolean).map(function (w) { return 'title:' + w; }).join(' ');
  }

  function buildFetchURL(view, page) {
    var url;
    if (view.mode === 'search') {
      url = SEARCH_PATH + '?q=' + encodeURIComponent(titleScope(view.query)) +
        '&type=article&view=articles&options[prefix]=last&section_id=' + view.sectionId;
    } else {
      var sep = view.baseHref.indexOf('?') === -1 ? '?' : '&';
      url = view.baseHref + sep + 'section_id=' + view.sectionId;
    }
    if (page > 1) url += '&page=' + page;
    return url;
  }

  function buildDisplayURL(view, page) {
    var url;
    if (view.mode === 'search') {
      url = BLOG_BASE + '?q=' + encodeURIComponent(view.query);
      if (page > 1) url += '&page=' + page;
    } else if (view.mode === 'tag') {
      url = view.baseHref;
      if (page > 1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'page=' + page;
    } else {
      url = BLOG_BASE;
      if (page > 1) url += '?page=' + page;
    }
    return url;
  }

  function pushHistory(view, page, mode) {
    if (mode === 'none') return;
    var url = buildDisplayURL(view, page);
    if (mode === 'replace') window.history.replaceState({}, '', url);
    else window.history.pushState({}, '', url);
  }

  function swap(html) {
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-en-blog-results]');
    if (!next) return false;
    results.innerHTML = next.innerHTML;
    markCardsShown();
    return true;
  }

  function loadView(view, page, mode) {
    // Instant path: all-articles page 1 from cache.
    if (view.mode === 'all' && page === 1 && allHTML !== null) {
      if (controller) { controller.abort(); controller = null; }
      results.innerHTML = allHTML;
      markCardsShown();
      setLoading(false);
      currentView = view; currentPage = 1;
      pushHistory(view, 1, mode);
      return;
    }
    // all/tag modes need the blog section id (absent on the standalone search page).
    if (view.mode !== 'search' && !view.sectionId) return;

    if (controller) controller.abort();
    controller = new AbortController();
    setLoading(true);
    currentView = view; currentPage = page;

    fetch(buildFetchURL(view, page), { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('Request failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (swap(html) && view.mode === 'all' && page === 1) allHTML = results.innerHTML;
        setLoading(false);
        controller = null;
        pushHistory(view, page, mode);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        setLoading(false);
      });
  }

  function run(query, updateHistory) {
    query = (query || '').trim();
    showClear(query.length > 0);
    var wasSearch = currentView && currentView.mode === 'search';

    if (query.length < MIN_CHARS) {
      if (currentView && currentView.mode === 'all' && currentPage === 1) return;
      setActivePill(allPill);
      loadView(allView(), 1, updateHistory ? 'replace' : 'none');
      return;
    }

    setActivePill(null); // searching is its own axis — no topic active
    var mode = updateHistory ? (wasSearch ? 'replace' : 'push') : 'none';
    loadView(searchView(query), 1, mode);
  }

  // Typing — debounced on pause
  input.addEventListener('input', function () {
    var q = input.value;
    showClear(q.trim().length > 0);
    clearTimeout(timer);
    timer = setTimeout(function () { run(q, true); }, DEBOUNCE);
  });

  // Enter — immediate
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(timer);
    run(input.value, true);
  });

  // Clear
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      showClear(false);
      clearTimeout(timer);
      run('', true);
      input.focus();
    });
  }

  // Topic pills — in-place tag filter (clears any active search)
  pills.forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      e.preventDefault();
      input.value = '';
      showClear(false);
      clearTimeout(timer);
      setActivePill(pill);
      var tag = pill.getAttribute('data-en-blog-filter-tag');
      if (tag) loadView(tagView(tag, pill.getAttribute('href')), 1, 'push');
      else loadView(allView(), 1, 'push');
    });
  });

  // Pagination — in place, in whatever mode is current
  results.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('.pagination a') : null;
    if (!link || !currentView) return;
    e.preventDefault();
    loadView(currentView, pageFromHref(link.getAttribute('href')), 'push');
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Back / forward
  window.addEventListener('popstate', function () {
    var path = window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    var page = parseInt(params.get('page') || '1', 10);
    var tagMatch = path.match(/\/tagged\/([^/?]+)/);
    if (q) {
      input.value = q; showClear(true); setActivePill(null);
      loadView(searchView(q), page, 'none');
    } else if (tagMatch) {
      input.value = ''; showClear(false);
      setActivePill(pillForTag(tagMatch[1]));
      loadView(tagView(tagMatch[1]), page, 'none');
    } else {
      input.value = ''; showClear(false); setActivePill(allPill);
      loadView(allView(), page, 'none');
    }
  });

  // Init — adopt the server-rendered state without a redundant fetch where possible
  (function init() {
    var path = window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    var page = parseInt(params.get('page') || '1', 10);
    var tagMatch = path.match(/\/tagged\/([^/?]+)/);

    if (tagMatch) {
      currentView = tagView(tagMatch[1]);
      currentPage = page;
    } else if (q) {
      if (page === 1) allHTML = results.innerHTML; // server rendered all articles (blog ignores q)
      input.value = q; showClear(true); setActivePill(null);
      loadView(searchView(q), page, 'none');
    } else {
      currentView = allView();
      currentPage = page;
      if (page === 1) allHTML = results.innerHTML;
    }
  })();
})();